export default "__VITE_ASSET__Do3sI3iH__"